import { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

const FEEDBACK_KEY_PREFIX = 'presentation_project_feedback';

const useFirstDownloadFeedback = () => {
  const user = useSelector((state) => state.auth.user);
  const [openFeedback, setOpenFeedback] = useState(false);

  const storageKey = useMemo(() => {
    const userId = user?.id || '';
    const fingerprint = localStorage.getItem('fingerprint-v2') || '';
    return `${FEEDBACK_KEY_PREFIX}_${userId}_${fingerprint}`;
  }, [user?.id]);

  const hasFirstDownloaded =
    !user?.id || localStorage.getItem(storageKey) === 'true';

  const markFirstDownloaded = useCallback(() => {
    if (!user?.id) return;
    localStorage.setItem(storageKey, 'true');
  }, [storageKey, user?.id]);

  return {
    hasFirstDownloaded,
    markFirstDownloaded,
    openFeedback,
    setOpenFeedback,
  };
};

export default useFirstDownloadFeedback;
